import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { SalaryDetails } from "../../Models/Marketer";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class RecieveSalariesVM extends InterActive{
    private list:SalaryDetails[] = []

    public get List():SalaryDetails[] { return this.list }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.waitingSalariesList()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.list = response.data.data
                                this.update()
                            }else Notify({type:'success' , title:'مشكلة' , body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
                }
            }
        )
    }

    public async acceptSalary(id:string){
        try{
            const response = await ApiRequest.acceptSalary(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                    }
                }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{
            Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
        }
    }

}